import anaConsts from 'analytics/constants';
import analyticsUtils from 'analytics/utils';

const {
    EVENT_NAMES: { BEAUTY_PREFERENCES },
    NAV_PATH: { TOP_NAV, ACCOUNT }
} = anaConsts;

function setPageLoadAnalytics() {
    const pageName = `${anaConsts.PAGE_NAMES.MY_SEPHORA}:${anaConsts.PAGE_NAMES.BEAUTY_PREFERENCES}:n/a:*`;
    digitalData.page.category.pageType = anaConsts.PAGE_NAMES.BEAUTY_PREFERENCES;
    digitalData.page.pageInfo.pageName = pageName;
}

function setNextPageLoadAnalyticsData(...args) {
    const navigationInfo = analyticsUtils.buildNavPath([...args]);
    analyticsUtils.setNextPageData({ navigationInfo });
}

function setFlyoutNextPage() {
    const { PREFERENCES } = BEAUTY_PREFERENCES;
    setNextPageLoadAnalyticsData(TOP_NAV, ACCOUNT, PREFERENCES, PREFERENCES, PREFERENCES);
}

export default {
    setPageLoadAnalytics,
    setNextPageLoadAnalyticsData,
    setFlyoutNextPage
};
